import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  Box,
  Tabs,
  Tab,
  IconButton,
  Typography,
} from "@mui/material";
import closeicon from "../assets/images/closeicon.png";
import DynamicBarChart from "./DynamicBarChart";
import MultiTableView from "./MultiTableView";

const ReportDialog = ({
  open,
  handleClose,
  toolResults,
  additional_agent_responses,
  reformatted_question,
}) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const toPascalCase = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="lg" // Changed from "md" to "lg" to increase width
      PaperProps={{
        sx: {
          height: "90vh",
          maxHeight: "900px",
          width: "90%", // Added to ensure it takes up more width
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span style={{ fontWeight: "bold" }}>Detailed View</span>
          <IconButton onClick={handleClose} size="small">
            <img src={closeicon} style={{ width: "20px" }} alt="close" />
          </IconButton>
        </Box>
      </DialogTitle>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="report tabs"
          >
            <Tab
              label="CHART VIEW"
              // visibility={toolResults.length > 1 ? "visible" : "hidden"}
              // sx={toolResults.length > 1 ? {} : { display: "none" }}
            />
            <Tab label="TABLE VIEW" />
            {Object.keys(additional_agent_responses || {}).length > 1 && (
              <Tab label="SOURCE INSIGHTS Summary " />
            )}
          </Tabs>
        </Box>
        <Box sx={{ p: 3, minHeight: "550px" }}>
          {tabValue === 0 && (
            <Box>
              {/* Chart View Content */}
              <DynamicBarChart toolResults={toolResults || []} />
            </Box>
          )}
          {tabValue === 1 && (
            <Box>
              {/* Table View Content */}
              <MultiTableView toolResults={toolResults || []} reformatted_question={reformatted_question} />
            </Box>
          )}
          {tabValue === 2 && (
            <Box>
              {Object.keys(additional_agent_responses || {}).map((key) => (
                <Box
                  key={key}
                  sx={{ mb: 1, borderBottom: 1, borderColor: "divider" }}
                >
                  <h4>{toPascalCase(key)}:</h4>
                  <Typography
                    sx={{ mb: 3 }}
                    dangerouslySetInnerHTML={{
                      __html: additional_agent_responses[key]
                        // eslint-disable-next-line react/prop-types
                        ? additional_agent_responses[key]
                            .replace(/^\s*### (.*)$/gm, "<h1>$1</h1>")
                            .replace(/^\s*## (.*)$/gm, "<h1>$1</h1>")
                            .replace(/^\s*# (.*)$/gm, "<h1>$1</h1>")
                            .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
                            // .replace(/\n/g, "<br>")
                        : "Not available.",
                    }}
                  ></Typography>
                  {/* <Typography>{additional_agent_responses[key]}</Typography> */}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

ReportDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  toolResults: PropTypes.array,
  additional_agent_responses: PropTypes.object,
  reformatted_question: PropTypes.string
};

export default ReportDialog;
